import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "addCommentContainer" }
const _hoisted_2 = { class: "btn btn-link" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "addCommentAttachment"
}
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_auto_textarea = _resolveComponent("auto-textarea")!
  const _component_icon_clip = _resolveComponent("icon-clip")!
  const _component_file_input = _resolveComponent("file-input")!
  const _component_icon_send = _resolveComponent("icon-send")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "commentAttachmentDropArea droparea",
        onDrop: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
      }, " Rilascia qui per allegare ", 32),
      _createVNode(_component_auto_textarea, {
        class: "form-control",
        placeholder: "Scrivi qui",
        modelValue: _ctx.localValue.text,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.text) = $event)),
        maxHeight: 150
      }, null, 8, ["modelValue"]),
      _createElementVNode("label", _hoisted_2, [
        _createVNode(_component_icon_clip),
        _createVNode(_component_file_input, {
          class: "hidden",
          modelValue: _ctx.tempFile,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempFile) = $event)),
            _ctx.addFile
          ]
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success",
          disabled: !_ctx.canSaveComment,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args)))
        }, [
          _createVNode(_component_icon_send)
        ], 8, _hoisted_3)
      ], true)
    ]),
    (_ctx.localValue.fileList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.fileList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name
            }, [
              _createTextVNode(" Allegato: " + _toDisplayString(item.name) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger btn-sm",
                onClick: ($event: any) => (_ctx.removeFile(item))
              }, " x ", 8, _hoisted_5)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}